import { ReleaseTable } from '@/components/analytics/ReleaseTable.tsx'
import { Button } from '@/components/ui/button.tsx'
import { STORY_STATUSES } from '@/constants/STORY_STATUSES.ts'
import { useUserContext } from '@/contexts/UserContext.tsx'
import { useProjectId } from '@/hooks/useProjectId.ts'
import { useQueryAnalyticsReleaseFlags } from '@/requests/queries/useQueryAnalytics.tsx'
import { useNavigate } from 'react-router-dom'

export const RecentReleases = () => {
  const { apiKey } = useUserContext()
  const navigate = useNavigate()
  const projectId = useProjectId()

  const { data: acceptedReleases } = useQueryAnalyticsReleaseFlags(apiKey, STORY_STATUSES.ACCEPTED)
  const { data: unstartedReleases } = useQueryAnalyticsReleaseFlags(apiKey, STORY_STATUSES.UNSTARTED)

  if (!acceptedReleases || !unstartedReleases) return

  const releases = [...(acceptedReleases?.releases.slice(-3) ?? []), ...(unstartedReleases?.releases.slice(0, 3) ?? [])]

  return (
    <div>
      <div className="flex justify-between items-center mb-2 h-8">
        <h2 className="font-EN-KR-sub-heading-bold text-contents-tertiary">Recent Releases</h2>
        {releases.length > 0 && (
          <Button
            variant="primary"
            type="button"
            className="h-6 py-[5px] px-2 rounded-xs font-EN-KR-caption-bold"
            onClick={() => navigate(`/project/${projectId}/releases`)}
          >
            View Releases Report
          </Button>
        )}
      </div>
      <ReleaseTable releases={releases} />
    </div>
  )
}
